import {takeLatest, put, call} from 'redux-saga/effects'
import {SEND_VERIFY_EMAIL_ALERT_RECIPIENT} from 'actions/verifyEmailAlertRecipient/constants'
import {getVerifyEmailAlertRecipient} from 'api/verifyEmailAlertRecipient'
import * as act from 'actions/index'
import {isInvalidTokenVerifyEmailAlertRecipient, setMessageVerifyEmailAlertRecipient} from 'actions/verifyEmailAlertRecipient'

export function * verifyEmailAlertRecipient (request) {
  yield put(act.showLoadingSpinner(true))
  try {
    let {token} = request.payload
    let resVerifyEmail = yield call(getVerifyEmailAlertRecipient, {token: token})
    yield put(setMessageVerifyEmailAlertRecipient(resVerifyEmail.data.message))
    yield put(isInvalidTokenVerifyEmailAlertRecipient(resVerifyEmail.data.error))
  } catch (error) {

  } finally {
    yield put(act.showLoadingSpinner(false))
  }
}

export default function * verifyEmailAlertRecipientSaga () {
  yield takeLatest(SEND_VERIFY_EMAIL_ALERT_RECIPIENT, verifyEmailAlertRecipient)
}



// WEBPACK FOOTER //
// ./app/sagas/verifyEmailAlertRecipient/index.js